import Vue from 'vue';
import { initialState } from './state';
import StoreModuleService from '../StoreModuleService';

// mutations declarations
export const REMOVE_EDGE = 'REMOVE_EDGE';
export const SET_EDGE_DATA = 'SET_EDGE_DATA';
export const SET_EDGES_DATA = 'SET_EDGES_DATA';
export const CLEAR_EDGES_DATA = 'CLEAR_EDGES_DATA';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_EDGE_DATA](state, { id, data }) {
		Vue.set(state.data, id, data);
	},
	[SET_EDGES_DATA](state, { data }) {
		Vue.set(state, 'data', data);
	},
	[CLEAR_EDGES_DATA](state) {
		Vue.set(state, 'data', {});
	},
	[REMOVE_EDGE](state, { id }) {
		Vue.delete(state.data, id);
	},
};

export default mutations;
